// v10
(function () {
  const COLOR_OPTION_INDEX = 0;
  const FILTER_API_KEY = 'UnknownRunnerVariantImageFilter';
  const initializedGalleries = new WeakSet();

  function normalizeAlt(alt) {
    return (alt || '').trim().toLowerCase();
  }

  function isRollover(alt) {
    return /^.+ rollover$/.test(normalizeAlt(alt));
  }

  function getItemAlt(item) {
    const img = item.querySelector('img');
    return img ? (img.getAttribute('alt') || '').trim() : '';
  }

  function getMediaItems(gallery) {
    return Array.from(gallery.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)'));
  }

  function getThumbnailItems(gallery) {
    return Array.from(gallery.querySelectorAll('.product__thumbs-item:not(.swiper-slide-duplicate)'));
  }

  function getOriginalMediaIndex(item) {
    return Number(item.dataset.mediaIndex);
  }

  function sortMediaByOriginalOrder(items) {
    return items.slice().sort(function(a, b) {
      return getOriginalMediaIndex(a) - getOriginalMediaIndex(b);
    });
  }

  function sortThumbnailsByOriginalOrder(items, mediaIndexById) {
    return items.slice().sort(function(a, b) {
      return mediaIndexById.get(a.dataset.target) - mediaIndexById.get(b.dataset.target);
    });
  }

  function setItemVisibility(item, isVisible) {
    if (isVisible) {
      item.style.removeProperty('display');
      item.removeAttribute('aria-hidden');
    } else {
      item.style.setProperty('display', 'none', 'important');
      item.setAttribute('aria-hidden', 'true');
    }
  }

  function moveHiddenItemsAfterVisibleItems(container, items, isVisible) {
    if (!container) return;

    items.filter(isVisible).forEach(function(item) {
      container.appendChild(item);
    });
    items.filter(function(item) {
      return !isVisible(item);
    }).forEach(function(item) {
      container.appendChild(item);
    });
  }

  function updateImageLoadingPriorities(items, visibleMediaIds) {
    let eligiblePosition = 0;

    items.forEach(function(item) {
      const isVisible = visibleMediaIds.has(item.dataset.mediaId);
      const loading = isVisible && eligiblePosition < 3 ? 'eager' : 'lazy';
      const fetchPriority = isVisible && eligiblePosition === 0 ? 'high' : 'low';

      item.querySelectorAll('img').forEach(function(image) {
        image.setAttribute('loading', loading);
        image.setAttribute('fetchpriority', fetchPriority);
      });

      if (isVisible) eligiblePosition += 1;
    });
  }

  function refreshPhotoSwipe(gallery) {
    if (gallery.dataset.enableImageZoom !== 'true' || typeof gallery.initImageZoom !== 'function') return;

    const eligibleItems = getMediaItems(gallery).filter(function(item) {
      return item.style.getPropertyValue('display') !== 'none' && item.getAttribute('aria-hidden') !== 'true';
    });
    gallery.initImageZoom(eligibleItems);
  }

  function arrangeInitialGallery(gallery) {
    const items = sortMediaByOriginalOrder(getMediaItems(gallery));
    if (!items.length) return;

    const visibleMediaIds = new Set();
    items.forEach(function(item) {
      const isVisible = item.style.getPropertyValue('display') !== 'none';
      if (isVisible) {
        item.removeAttribute('aria-hidden');
        visibleMediaIds.add(item.dataset.mediaId);
      } else {
        item.setAttribute('aria-hidden', 'true');
      }
    });

    moveHiddenItemsAfterVisibleItems(
      gallery.querySelector('[id^="Slider-Gallery"]'),
      items,
      function(item) {
        return visibleMediaIds.has(item.dataset.mediaId);
      }
    );

    const mediaIndexById = new Map(items.map(function(item) {
      return [item.dataset.mediaId, getOriginalMediaIndex(item)];
    }));
    const thumbnails = sortThumbnailsByOriginalOrder(getThumbnailItems(gallery), mediaIndexById);
    thumbnails.forEach(function(item) {
      setItemVisibility(item, visibleMediaIds.has(item.dataset.target));
    });
    moveHiddenItemsAfterVisibleItems(
      gallery.querySelector('[id^="Slider-Thumbnails"]'),
      thumbnails,
      function(item) {
        return visibleMediaIds.has(item.dataset.target);
      }
    );

    refreshPhotoSwipe(gallery);
  }

  function filterGallery(gallery, selectedColor) {
    const items = sortMediaByOriginalOrder(getMediaItems(gallery));
    if (!items.length) return;

    const imageItems = items.filter(function(item) {
      return item.dataset.mediaType === 'image';
    });
    const selectedLower = normalizeAlt(selectedColor);
    const colorAlts = imageItems.map(getItemAlt).filter(function(alt) {
      return alt && !isRollover(alt);
    });
    const hasColorTaggedImages = colorAlts.some(function(alt) {
      return normalizeAlt(alt) === selectedLower;
    });
    const visibleMediaIds = new Set();

    items.forEach(function(item) {
      let isVisible = true;

      if (item.dataset.mediaType === 'image') {
        const alt = getItemAlt(item);
        const altLower = normalizeAlt(alt);
        isVisible = !isRollover(alt) && (!alt || !hasColorTaggedImages || altLower === selectedLower);
        setItemVisibility(item, isVisible);
      }

      if (isVisible) visibleMediaIds.add(item.dataset.mediaId);
    });

    updateImageLoadingPriorities(items, visibleMediaIds);

    moveHiddenItemsAfterVisibleItems(
      gallery.querySelector('[id^="Slider-Gallery"]'),
      items,
      function(item) {
        return visibleMediaIds.has(item.dataset.mediaId);
      }
    );

    const mediaIndexById = new Map(items.map(function(item) {
      return [item.dataset.mediaId, getOriginalMediaIndex(item)];
    }));
    const thumbnails = sortThumbnailsByOriginalOrder(getThumbnailItems(gallery), mediaIndexById);
    thumbnails.forEach(function(item) {
      setItemVisibility(item, visibleMediaIds.has(item.dataset.target));
    });
    moveHiddenItemsAfterVisibleItems(
      gallery.querySelector('[id^="Slider-Thumbnails"]'),
      thumbnails,
      function(item) {
        return visibleMediaIds.has(item.dataset.target);
      }
    );

    refreshPhotoSwipe(gallery);
  }

  function updateSwiper(swiper) {
    if (!swiper || swiper.destroyed) return;

    swiper.update();
    swiper.slideTo(0, 0, false);
    if (swiper.pagination && typeof swiper.pagination.render === 'function') {
      swiper.pagination.render();
    }
    if (swiper.pagination && typeof swiper.pagination.update === 'function') {
      swiper.pagination.update();
    }
    if (typeof swiper.updateAutoHeight === 'function') {
      swiper.updateAutoHeight(0);
    }
  }

  function synchronizeSwiper(gallery) {
    const thumbsSwiper = gallery.thumbsInstance && gallery.thumbsInstance.slider;
    const swiper = gallery.sliderInstance && gallery.sliderInstance.slider;

    updateSwiper(thumbsSwiper);
    updateSwiper(swiper);
    if (swiper && swiper.thumbs && typeof swiper.thumbs.update === 'function') {
      swiper.thumbs.update(true);
    }
  }

  function finalizeInitialGallery(gallery) {
    const swiper = gallery.sliderInstance && gallery.sliderInstance.slider;
    if (!swiper) arrangeInitialGallery(gallery);
    synchronizeSwiper(gallery);
  }

  function observeSwiperInitialization(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    if (viewer.classList.contains('swiper-initialized')) {
      finalizeInitialGallery(gallery);
      return;
    }

    const observer = new MutationObserver(function() {
      if (!viewer.classList.contains('swiper-initialized')) return;
      observer.disconnect();
      finalizeInitialGallery(gallery);
    });
    observer.observe(viewer, { attributes: true, attributeFilter: ['class'] });
  }

  function synchronizeAfterInitialFeaturedMedia(productInfo, gallery) {
    customElements.whenDefined('media-gallery').then(function() {
      if (!gallery.isConnected) return;

      refreshPhotoSwipe(gallery);

      const selectedVariant = getSelectedVariant(productInfo);
      if (!selectedVariant || typeof gallery.setActiveMedia !== 'function') {
        const expectsSlider = window.FoxTheme &&
          (FoxTheme.config.mqlMobile || gallery.dataset.enableDesktopSlider === 'true');
        if (!expectsSlider) {
          finalizeInitialGallery(gallery);
          return;
        }
        observeSwiperInitialization(gallery);
        return;
      }

      if (gallery.elements && productInfo.timer === undefined) {
        finalizeInitialGallery(gallery);
        return;
      }

      const setActiveMedia = gallery.setActiveMedia;
      gallery.setActiveMedia = function(variant) {
        const result = setActiveMedia.call(this, variant);
        delete this.setActiveMedia;
        finalizeInitialGallery(this);
        return result;
      };
    });
  }

  function getSelectedVariant(productInfo) {
    const variantJson = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (!variantJson || !variantJson.textContent.trim()) return null;

    try {
      return JSON.parse(variantJson.textContent);
    } catch (error) {
      return null;
    }
  }

  function initializeProductInfo(productInfo) {
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery || initializedGalleries.has(gallery)) return;

    initializedGalleries.add(gallery);
    arrangeInitialGallery(gallery);
    synchronizeAfterInitialFeaturedMedia(productInfo, gallery);
  }

  function initializeProductInfos(context) {
    const productInfos = [];
    if (context.matches && context.matches('product-info')) productInfos.push(context);
    productInfos.push.apply(productInfos, context.querySelectorAll('product-info'));
    productInfos.forEach(initializeProductInfo);
  }

  function synchronizeProductInfo(productInfo, variant) {
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return;

    const color = variant.options && variant.options[COLOR_OPTION_INDEX];
    filterGallery(gallery, color || '');
    synchronizeSwiper(gallery);
  }

  if (window[FILTER_API_KEY]) {
    window[FILTER_API_KEY].initializeProductInfos(document);
    return;
  }

  window[FILTER_API_KEY] = {
    initializeProductInfos: initializeProductInfos,
  };

  document.addEventListener('variant:changed', function(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('product-info').forEach(function(productInfo) {
      const selectedVariant = getSelectedVariant(productInfo);
      if (selectedVariant && selectedVariant.id === variant.id) {
        synchronizeProductInfo(productInfo, variant);
      }
    });
  });

  document.addEventListener('shopify:section:load', function(event) {
    initializeProductInfos(event.target);
  });

  initializeProductInfos(document);
})();
